export default __webpack_public_path__ + "static/media/question.6d77a04e.svg";